import { Box, Modal, Typography } from "@mui/material";
import MDButton from "components/MDButton";
import LedgerRow from "./LedgerRow";
import RevenueInputForm from "./RevenueInputForm";

const modalStyle = {
  position: "absolute",
  top: "50%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  maxHeight: "80%",
  height: "80%",
  bgcolor: "background.paper",
  boxShadow: 24,
  p: 4,
  "& .MuiFormHelperText-root": { color: "#d32f2f" },
  borderRadius: "0.5rem",
  outline: "none",
  display: "flex",
  flexDirection: "column",
};

function RevenueLedgerModal({
  open,
  handleClose,
  ledgerData,
  dateDisplay,
  selectedTab,
  handleRestoreRevenue,
  handleDeleteRevenue,
  handleEditRevenue,
  viewAsIndividual,
  viewingKpiId,
  fetchRevenueData,
  handleOpenLedgerModal,
  loginUserReportingHierarchy,
  allowRevenueInput,
}) {
  return (
    <Modal
      open={open}
      onClose={handleClose}
      aria-labelledby="modal-modal-title"
      aria-describedby="modal-modal-description"
    >
      <Box
        sx={{
          ...modalStyle,
          width: {
            xs: "90%",
            md: "700px",
          },
        }}
      >
        <Box
          sx={{
            width: "100%",
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
          }}
        >
          <Typography variant="h4" sx={{ mb: "1rem" }}>
            Revenue Ledger
          </Typography>
          <Typography
            variant="caption"
            color="info"
            sx={{ mb: "1rem", display: "block", fontSize: "0.9rem" }}
          >
            {dateDisplay}
          </Typography>
        </Box>
        {viewAsIndividual && allowRevenueInput && !viewingKpiId && (
          <Box sx={{ mb: 4, mt: 1 }}>
            <RevenueInputForm
              fetchRevenueData={fetchRevenueData}
              handleOpenLedgerModal={handleOpenLedgerModal}
            />
          </Box>
        )}
        <Box sx={{ flex: 1, overflowY: "auto" }}>
          <Typography
            variant="h7"
            sx={{ mb: "1rem", color: "#888", fontSize: "0.9rem", fontWeight: "600" }}
          >
            NEWEST
          </Typography>
          <Box>
            {ledgerData.length ? (
              ledgerData.map((item) => (
                <LedgerRow
                  key={item.id}
                  row={item}
                  selectedTab={selectedTab}
                  handleRestoreRevenue={handleRestoreRevenue}
                  handleDeleteRevenue={handleDeleteRevenue}
                  handleEditRevenue={handleEditRevenue}
                  loginUserReportingHierarchy={loginUserReportingHierarchy}
                />
              ))
            ) : (
              <Typography sx={{ fontSize: "0.9rem", fontWeight: "400" }}>
                No Revenue Records
              </Typography>
            )}
          </Box>
        </Box>
        <Box sx={{ display: "flex", justifyContent: "flex-end" }}>
          <Box>
            <MDButton color="gray80" onClick={handleClose} sx={{ mt: 2, position: "relative" }}>
              Close
            </MDButton>
          </Box>
        </Box>
      </Box>
    </Modal>
  );
}

export default RevenueLedgerModal;
